export const ProjectWarning = {
  INFO: 1,
  WARN: 2,
  ERROR: 3
}